export const setBusinessHours = (hours) => {
  return {
    type: "SET_HOURS",
    data: hours,
  };
};
